module.exports = __webpack_public_path__ + "media/stylesheets/resident/images/ico-clinic-70e047d462cf2ffe925d98dbd69ade6a.svg";